@if (error) {
  <div class="error-state-card-container">
    <mat-card appearance="outlined" class="error-state-card">
      <h1 class="title">{{ title }}</h1>
      <p class="body">{{ body }}</p>

      @if (error.status === 404) {
        <la-button appearance="primary" (action)="navigateToMaps()">Go to maps</la-button>
      }
    </mat-card>
  </div>
}
